import { Fetch } from 'lib';
import type { SpecialOffer } from 'types';

type RequestResponses = SpecialOffer;

type RequestParameters = {
  id: string;
};

const getSpecialOffer = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminSpecialOffer/getSpecialOffer',
    params,
  });

export { getSpecialOffer };
